import React, { Component } from 'react';
class Footer extends Component {
    render() {
        
        return (
            <div>
                <div className="footer" style={{position:"fixed"}}>
                    <p>Copyright © Oxygen Global 2018. All rights reserved.</p>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.jsx